/**
 *
 * Asynchronously loads the component for Support
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
